<template>
    <div
        class="is-layout-flex wp-block-columns"
        :class="[excludeFromPrintClassName]"
    >
        <div
            v-for="(item, index) in value"
            :key="index"
            class="is-layout-flow wp-block-column"
            :style="{
                direction: 'ltr'
            }"
        >
            <figure class="wp-block-image">
                <picture v-full-image-path="item.image || {}" />

                <figcaption
                    v-if="item.description"
                    class="wp-element-caption"
                    v-html="item.description"
                />
            </figure>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
            required: true
        },

        excludeFromPrintClassName: {
            type: String,
            required: true
        }
    }
};
</script>
